import { cn } from '@/lib/utils';

export const toastStyles = {
  toast: {
    initial: cn(
      'group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full'
    ),
    title: 'text-sm font-semibold',
    description: 'text-sm opacity-90',
    actionButton: 'group-[.success]:bg-green-500 group-[.success]:text-green-50',
    cancelButton: 'group-[.success]:bg-green-100 group-[.success]:text-green-900',
    error: 'group-[.error]:border-red-500 group-[.error]:bg-red-100',
    success: 'group-[.success]:border-green-500 group-[.success]:bg-green-100',
    info: 'group-[.info]:border-blue-500 group-[.info]:bg-blue-100',
    warning: 'group-[.warning]:border-yellow-500 group-[.warning]:bg-yellow-100',
  },
};
